



















































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import moment from "moment";
import StorePersetujuanPlebotomi from "@/store/modules/PersetujuanPlebotomi";
import SvcPersetujuanPlebotomi from "@/services/PersetujuanPlebotomi";
import BaseCardSuketMultiple from "@/components/pemeriksaan/resumeSuketV2/BaseCardSuketMultiple.vue";
import BerkasPersetujuanDarah from "./BerkasPersetujuanDarah.vue";
import PersetujuanPlebotomiInputCard from "./PersetujuanPlebotomiInputCard.vue";
import {
  CHECKLIST_PLEBOTOMI,
  HUBUNGAN_PERSETUJUAN_DARAH
} from "./persetujuanLayananDarah";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { labelJk } from "@/utils/jenisKelamin";

@Component({
  components: {
    BerkasPersetujuanDarah,
    BaseCardSuketMultiple,
    PersetujuanPlebotomiInputCard
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class PersetujuanPlebotomiTabPage extends Vue {
  @Prop() readonly register!: string;

  @Prop({ type: Boolean, default: false }) readonly sembunyikanTambah!: boolean;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  expandInput = false;
  pageTab = "tab-soap";
  dataSuketActive: any = null;

  checklistItems = CHECKLIST_PLEBOTOMI;

  get dataSuket(): any[] {
    return StorePersetujuanPlebotomi.suket.map(item => ({
      ...item,
      dokter_id: item.signee_user_id,
      dokter: item.signee
    }));
  }

  get loadContent() {
    return StorePersetujuanPlebotomi.loading;
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  isi(slotProps: any) {
    return (slotProps && slotProps.content) || {};
  }

  pembuat(slotProps: any) {
    return this.isi(slotProps).pembuat_pernyataan || {};
  }

  dicentang(slotProps: any, key: string): boolean {
    const checklist = this.isi(slotProps).checklist || {};

    return !!checklist[key];
  }

  labelJenisKelamin(nilai: any): string {
    return labelJk(nilai) || "-";
  }

  labelHubungan(pembuat: any): string {
    const kode = pembuat && pembuat.hubungan;
    if (!kode) return "-";

    if (kode === "lainnya") {
      return pembuat.hubungan_lain || "Lainnya";
    }

    const found = HUBUNGAN_PERSETUJUAN_DARAH.find(o => o.value === kode);

    return found ? found.text : kode;
  }

  tglSurat(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : "-";
  }

  setActive(data) {
    this.dataSuketActive = data;
  }

  edit(data) {
    this.dataSuketActive = data;
    this.showInput();
  }

  add() {
    this.dataSuketActive = null;
    this.showInput();
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    SvcPersetujuanPlebotomi.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
    this.dataSuketActive = null;
  }

  muatUlang() {
    StorePersetujuanPlebotomi.getSuketByRegister(this.register);
  }

  setJumlahBerkas(payload: { id: number; jumlah: number }) {
    StorePersetujuanPlebotomi.SET_SUKET(
      StorePersetujuanPlebotomi.suket.map(s => (s.id === payload.id ? { ...s, berkas_count: payload.jumlah } : s))
    );
  }

  remove(item) {
    SvcPersetujuanPlebotomi.destroy(item.id).then(dt => {
      if (dt.status == 1) {
        appModule.NoticeDelay("Berhasil Hapus Persetujuan Plebotomi");
        StorePersetujuanPlebotomi.getSuketByRegister(this.register);
      } else {
        appModule.sendErrorAlert(dt.message);
      }
    });
  }
}
